import { AppModule } from '@app/types';

export const SearchModule: AppModule = {
  id: 'search',
  title: 'Search',
  basePath: 'search',
};
